import httpClient from "./httpClient";

const base = "/transfer-certificates";

export function saveTransferCertificate(payload) {
  return httpClient.post(base, payload).then((res) => res.data);
}

export function updateTransferCertificate(payload) {
  return httpClient.post(`${base}/update`, payload).then((res) => res.data);
}

export function listTransferCertificates(academicYear) {
  return httpClient.get(base, { params: { academicYear } }).then((res) => res.data.data);
}
